import { useInView } from "react-intersection-observer";
import styled from "styled-components";
import Image from "../../../assets/images/image/community-img.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { appear } from "../../animations/Appear";
import UnderlineButton from "../../buttons/UnderlineButton";

const Wrapper = styled.div`
  height: fit-content;
  width: 100%;
  /* border: 1px solid #7372722f; */
  /* background-color: #f8f6f661; */
  animation: ${({ inView }) => (inView ? appear : "none")} 2s forwards;
`;
const Container = styled.div`
  display: grid;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  padding: 0 40px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 950px) {
    grid-template-columns: 1fr;
    gap: 24px;
    justify-content: center;
  }
`;

const Left = styled.div`
  display: flex;
  max-width: 500px;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2rem;
  box-sizing: border-box;
  margin: 0 auto;

  span {
    letter-spacing: 0.14rem;
    color: ${colors.maroon};
    font-size: ${fontSize.m};
    font-weight: 200;
  }

  p {
    letter-spacing: 0.09rem;
    word-spacing: 0.1rem;
    line-height: 1.6;
    color: ${colors.primaryGray};
    font-size: ${fontSize.xxs};
  }

  @media (max-width: 950px) {
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 90vw;
  }
`;

const Right = styled.div`
  width: 100%;
  max-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  margin-left: auto;
  img {
    aspect-ratio: 2 / 1.2;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 950px) {
    width: 100%;
    max-width: 100%;
  }
`;

const Space = styled.div`
  height: 35px;

  @media (max-width: 950px) {
    height: 20px;
  }
`;

function CharitySection() {
  const { ref, inView } = useInView({
    triggerOnce: false,
  });
  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <Left>
          <span>Giving Back to the Mountains</span>
          <Space />
          <p>
            As people and as an organization born in the Himalayas, we believe
            it is our responsibility to give back to the mountains that sustain
            us. For many, the Himalayas represent nature and landscapes, but for
            us they also mean the people, heritage, and culture that have
            protected this land for centuries. These communities are deeply
            connected to the environment and have preserved its balance through
            generations.
          </p>
          <Space />
          <p>
            We believe it is our duty to protect both this environment and its
            heritage from exploitation. Through our manufacturing initiative,
            Forall Manufacturing, we ensure that what we harvest finds its way
            back to the people, creating meaningful work and uplifting local
            communities while preserving traditional knowledge.
          </p>
          <Space />

          <div>
            <UnderlineButton
              placeholder={"VISIT FORALL MANUFACTURING"}
              color={colors.maroon}
              onClick={() => {
                window.open("https://www.forallmanufacturing.com");
              }}
            />
          </div>
        </Left>
        <Right ref={ref} inView={inView}>
          <img src={Image} alt="" />
        </Right>
      </Container>
    </Wrapper>
  );
}

export default CharitySection;
